import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { CustomerServiceAnalyticsMenuLinkItem } from './ui/index.tsx';

export const CustomerServiceAnalytics = () => (
	<UFOSegment name="nav4-sidebar-customer-service-analytics">
		<JSErrorBoundary
			fallback="flag"
			id="assets"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentCustomerService"
			teamName="Kalari"
		>
			<CustomerServiceAnalyticsMenuLinkItem />
		</JSErrorBoundary>
	</UFOSegment>
);
